import { jsx } from "react/jsx-runtime";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { Box } from "@mantine/core";
import { useMergedRef } from "@mantine/hooks";
import { forwardRef, createRef, useState, useEffect } from "react";
import '../../../assets/ArrowHead.css';const root = "_root_r347a_2";
const arrowHead = "_arrowHead_r347a_23";
const PaperStyles = {
  root,
  arrowHead
};
const _ArrowHead = forwardRef((props, ref) => {
  const { target, variant, arrowPosition, ...rest } = props;
  const localRef = createRef();
  const mergedRef = useMergedRef(localRef, ref);
  const [direction, setDirection] = useState(
    arrowPosition || "left"
  );
  useEffect(() => {
    if (!localRef.current || !target.current || arrowPosition) {
      return;
    }
    const selfPos = localRef.current.getBoundingClientRect();
    const targetPos = target.current.getBoundingClientRect();
    if (targetPos && selfPos) {
      if (targetPos.x + targetPos.width < selfPos.x) {
        setDirection("left");
      } else if (targetPos.x > selfPos.x + selfPos.width) {
        setDirection("right");
      } else if (targetPos.y + targetPos.height < selfPos.y) {
        setDirection("top");
      } else if (targetPos.y > selfPos.y + selfPos.height) {
        setDirection("bottom");
      }
    }
  }, []);
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...rest,
      ref: mergedRef,
      className: PaperStyles.arrowHead,
      mod: { variant, direction },
      "data-test": `arrow-head-${direction}`
    }
  );
});
const ArrowHead = sharedHandler(_ArrowHead);
ArrowHead.displayName = _ArrowHead.displayName;
export {
  PaperStyles as P,
  ArrowHead as default
};
